import api from './api'
import {
  KnowledgeBase,
  KnowledgeSection,
  KnowledgeBlock,
  CreateKnowledgeBaseRequest,
  UpdateKnowledgeBaseRequest,
  DeleteKnowledgeBaseRequest,
  PublishKnowledgeBaseRequest,
  UnpublishKnowledgeBaseRequest,
  GetKnowledgeSectionRequest,
  CreateKnowledgeSectionRequest,
  UpdateKnowledgeSectionRequest,
  DeleteKnowledgeSectionRequest,
  GetKnowledgeBlocksRequest,
  CreateKnowledgeBlockRequest,
  UpdateKnowledgeBlockRequest,
  DeleteKnowledgeBlockRequest,
} from '@/models/knowledge'

class KnowledgeApiService {
  static getInstance(): KnowledgeApiService {
    return this.instance || (this.instance = new this())
  }

  private static instance: KnowledgeApiService

  private baseUrl = '/knowledge'

  private constructor() {
    // empty for linter
  }

  getKnowledgeBases() {
    const url = `${this.baseUrl}?expand=published,sections`
    return api.get<KnowledgeBase[]>(url)
  }

  getKnowledgeBase(id: string) {
    const url = `${this.baseUrl}/${id}/?expand=published,sections`
    return api.get<KnowledgeBase>(url)
  }

  createKnowledgeBase(data: CreateKnowledgeBaseRequest) {
    const url = `${this.baseUrl}`
    return api.post<KnowledgeBase>(url, data)
  }

  updateKnowledgeBase(data: UpdateKnowledgeBaseRequest) {
    const { id, ...payload } = data
    const url = `${this.baseUrl}/${id}`
    return api.post<boolean>(url, payload)
  }

  deleteKnowledgeBase(data: DeleteKnowledgeBaseRequest) {
    const { id } = data
    const url = `${this.baseUrl}/${id}`
    return api.delete<boolean>(url)
  }

  publishKnowledgeBase(data: PublishKnowledgeBaseRequest) {
    const { id } = data
    const url = `${this.baseUrl}/${id}/publish`
    return api.get<boolean>(url)
  }

  unpublishKnowledgeBase(data: UnpublishKnowledgeBaseRequest) {
    const { id } = data
    const url = `${this.baseUrl}/${id}/unpublish`
    return api.get<boolean>(url)
  }

  getKnowledgeSection(data: GetKnowledgeSectionRequest) {
    const { baseId, sectionId } = data
    const url = `${this.baseUrl}/${baseId}/sections/${sectionId}`
    return api.get<KnowledgeSection>(url)
  }

  createKnowledgeSection(data: CreateKnowledgeSectionRequest) {
    const { id, ...payload } = data
    const url = `${this.baseUrl}/${id}/sections`
    return api.post<KnowledgeSection>(url, payload)
  }

  updateKnowledgeSection(data: UpdateKnowledgeSectionRequest) {
    const { baseId, sectionId, ...payload } = data
    const url = `${this.baseUrl}/${baseId}/sections/${sectionId}`
    return api.post<boolean>(url, payload)
  }

  deleteKnowledgeSection(data: DeleteKnowledgeSectionRequest) {
    const { baseId, sectionId } = data
    const url = `${this.baseUrl}/${baseId}/sections/${sectionId}`
    return api.delete<boolean>(url)
  }

  getKnowledgeBlocks(data: GetKnowledgeBlocksRequest) {
    const { baseId, sectionId } = data
    const url = `${this.baseUrl}/${baseId}/sections/${sectionId}/blocks?expand=content`
    return api.get<KnowledgeBlock[]>(url)
  }

  createKnowledgeBlock(data: CreateKnowledgeBlockRequest) {
    const { baseId, sectionId, ...payload } = data
    const url = `${this.baseUrl}/${baseId}/sections/${sectionId}/blocks`
    return api.post<KnowledgeBlock>(url, payload)
  }

  updateKnowledgeBlock(data: UpdateKnowledgeBlockRequest) {
    const { baseId, sectionId, blockId, ...payload } = data
    const url = `${this.baseUrl}/${baseId}/sections/${sectionId}/blocks/${blockId}`
    return api.post<boolean>(url, payload)
  }

  deleteKnowledgeBlock(data: DeleteKnowledgeBlockRequest) {
    const { baseId, sectionId, blockId } = data
    const url = `${this.baseUrl}/${baseId}/sections/${sectionId}/blocks/${blockId}`
    return api.delete<boolean>(url)
  }
}

export default KnowledgeApiService.getInstance()
